import { render, staticRenderFns } from "./radio-payment-method.vue?vue&type=template&id=fd73ba42&scoped=true"
import script from "./radio-payment-method.vue?vue&type=script&lang=js"
export * from "./radio-payment-method.vue?vue&type=script&lang=js"
import style0 from "./radio-payment-method.vue?vue&type=style&index=0&id=fd73ba42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd73ba42",
  null
  
)

export default component.exports